import { useEffect } from 'react';
import { useRouter } from 'next/router';
import type { GetServerSideProps } from 'next';
import { APP_LOCALE } from '@99designs/design-services-common';
import { getBriefCreateURL } from '@99designs/i18n';
import { BRIEF_PAGE_NAME, PAGE_TRACKING_CONFIG } from '@99designs/tracking';

export const getServerSideProps: GetServerSideProps = async (context) => {
    const locale = context.locale ?? APP_LOCALE;
    return {
        props: {
            locale,
            pageConfig: {
                pageTracking: {
                    ...PAGE_TRACKING_CONFIG['design'],
                    pageName: BRIEF_PAGE_NAME,
                },
            },
            experiments: [],
        },
    };
};

export default function CreateBriefPage() {
    const router = useRouter();

    useEffect(() => {
        if (!router.isReady) return;

        const { productKey = 'other-design', ...query } = router.query;

        const destination = getBriefCreateURL().replace('other-design', productKey as string);
        const queryString = new URLSearchParams(query as Record<string, string>).toString();
        window.location.replace(queryString ? `${destination}?${queryString}` : destination);
    }, [router]);

    return null;
}
